import type { Locale } from '@/providers/Locale/types'

type Messages = Record<'edition', string>

export const i18n: Record<Locale, Messages> = {
    en: {
        edition: 'Editions',
    },
    es: {
        edition: 'Ediciones',
    },
    fr: {
        edition: 'Éditions',
    },
    de: {
        edition: 'Editionen',
    },
}
